import type { User } from '@/types/auth';

export const hasRevokedAccess = (
  user: User | null | undefined,
): boolean => Boolean(user && !user.is_active);
